export const CHECKOUT_URL = 'https://menopausia-it.impultienda.ar/checkout/'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/1nke26eix8mukSfdgFz9pL/MENOPAUSIA-IT.png'

export const stats = [
  { value: '300+', label: 'Algoritmi clinici' },
  { value: '2.000+', label: 'Medici che usano il sistema' },
  { value: '1.500+', label: 'Ore risparmiate ogni anno' },
  { value: '99%', label: 'Lo consiglierebbe ai colleghi' },
]

export const patientCases = [
  'Una paziente presenta vampate di calore severe.',
  'Un’altra ha una forte storia familiare di tumore al seno.',
  'Un’altra ancora presenta obesità e rischio cardiovascolare.',
  'Un’altra sviluppa sanguinamento inatteso dopo aver iniziato la terapia ormonale.',
]

export const steps = [
  {
    number: '1',
    kicker: 'Passaggio 1',
    title: 'Identifica Rapidamente la Paziente Giusta',
    body: 'Determina se la tua paziente è realmente una candidata appropriata alla Terapia Ormonale della Menopausa utilizzando algoritmi clinici strutturati.',
    highlights: ['Nessun esame non necessario.', 'Nessuna incertezza.'],
  },
  {
    number: '2',
    kicker: 'Passaggio 2',
    title: 'Valuta il Rischio Clinico in Pochi Minuti',
    body: 'Valuta il rischio cardiovascolare, tromboembolico e di tumore al seno utilizzando pratici alberi decisionali basati sulle evidenze.',
    highlights: ['Saprai quando il trattamento è appropriato.', 'Saprai quando non lo è.'],
  },
  {
    number: '3',
    kicker: 'Passaggio 3',
    title: 'Scegli il Miglior Trattamento',
    body: 'Seleziona l’ormone giusto. La dose giusta. La modalità di somministrazione giusta. Per la paziente giusta.',
    highlights: ['Ogni volta.'],
  },
  {
    number: '4',
    kicker: 'Passaggio 4',
    title: 'Ottimizza i Risultati nel Lungo Periodo',
    body: 'Saprai esattamente cosa monitorare, quando effettuare il follow-up, quando modificare la terapia, quando cambiare trattamento e quando interromperla.',
    highlights: ['Senza affidarti a supposizioni.'],
    list: [
      'Cosa monitorare',
      'Quando effettuare il follow-up',
      'Quando modificare la terapia',
      'Quando cambiare trattamento',
      'Quando interrompere la terapia',
    ],
  },
]

export const beforeItems = [
  'Cercare informazioni in numerose linee guida',
  'Incertezza sull’idoneità alla terapia ormonale',
  'Paura di prendere la decisione prescrittiva sbagliata',
  'Follow-up incoerente',
  'Consultazioni lunghe e complicate',
  'Mettere continuamente in dubbio le proprie decisioni',
]

export const afterItems = [
  'Seguire un unico percorso clinico strutturato',
  'Selezionare le pazienti con sicurezza grazie ad algoritmi chiari',
  'Prendere decisioni terapeutiche basate sulle evidenze',
  'Utilizzare protocolli di monitoraggio standardizzati',
  'Rendere le visite cliniche più rapide ed efficienti',
  'Avere maggiore sicurezza in ogni decisione clinica',
]

export const painPoints = [
  'Non sei sicuro di quando iniziare la Terapia Ormonale della Menopausa.',
  'Esiti tra trattamento orale e transdermico.',
  'Non sai con certezza come gestire pazienti con rischio cardiovascolare o di tumore al seno.',
  'Passi troppo tempo a consultare numerose linee guida cliniche.',
  'Le pazienti ti pongono domande difficili sulla sicurezza degli ormoni e vorresti che le tue risposte fossero più sicure.',
  'Ogni consultazione sulla menopausa sembra diversa, rendendo difficile standardizzare il tuo approccio clinico.',
]

export const volumes = [
  {
    number: 'Volume 1',
    title: 'Il Progetto della Valutazione Clinica',
    lead: 'Impara a identificare la paziente giusta prima di prendere la tua prima decisione terapeutica.',
    body: 'Sviluppa un approccio clinico strutturato per valutare le donne in menopausa utilizzando percorsi di valutazione basati sulle evidenze.',
    listTitle: 'All’interno imparerai:',
    items: [
      'Valutazione dei sintomi',
      'Diagnosi differenziale',
      'Stadiazione della menopausa',
      'Finestra di opportunità',
      'Esami di laboratorio iniziali',
      'Algoritmi di valutazione clinica',
      'Esempi reali di pazienti',
    ],
  },
  {
    number: 'Volume 2',
    title: 'Il Progetto della Valutazione del Rischio',
    lead: 'Determina con sicurezza chi è, e chi non è, una candidata alla Terapia Ormonale della Menopausa.',
    body: 'Smetti di indovinare. Inizia a effettuare valutazioni del rischio basate sulle evidenze in pochi minuti.',
    listTitle: 'All’interno scoprirai:',
    items: [
      'Valutazione del rischio cardiovascolare',
      'Valutazione del rischio di tumore al seno',
      'Screening del tromboembolismo venoso',
      'Controindicazioni',
      'Selezione della paziente',
      'Algoritmi clinici di sicurezza',
      'Strumenti per il processo decisionale condiviso',
    ],
  },
  {
    number: 'Volume 3',
    title: 'Il Manuale della Terapia Ormonale',
    lead: 'Seleziona l’ormone giusto, la dose giusta e la modalità di somministrazione giusta per ogni paziente.',
    body: 'Niente più incertezza durante la prescrizione. Tutto è organizzato in percorsi pratici per la prescrizione clinica.',
    listTitle: 'Include:',
    items: [
      'Selezione degli estrogeni',
      'Selezione del progesterone',
      'Terapia orale o transdermica',
      'Terapia ormonale vaginale',
      'Dosaggio iniziale',
      'Strategie di mantenimento',
      'Terapia combinata',
      'Algoritmi clinici per la prescrizione',
    ],
  },
  {
    number: 'Volume 4',
    title: 'Ottimizzazione del Trattamento',
    lead: 'Scopri esattamente quando modificare, cambiare o interrompere la terapia.',
    body: 'Perché una terapia ormonale efficace non termina con la prescrizione. Richiede un’ottimizzazione continua.',
    listTitle: 'Imparerai a:',
    items: [
      'Gestire gli effetti collaterali',
      'Modificare le dosi',
      'Applicare strategie di monitoraggio',
      'Interpretare il follow-up di laboratorio',
      'Ottimizzare la terapia',
      'Gestire il trattamento a lungo termine',
    ],
  },
  {
    number: 'Volume 5',
    title: 'Scenari Clinici Avanzati',
    lead: 'Gestisci con sicurezza le pazienti che non rientrano nel protocollo standard.',
    body: 'Scopri come gli specialisti esperti nella menopausa affrontano i casi più complessi.',
    listTitle: 'Include:',
    items: [
      'Sopravvissute al tumore al seno',
      'Insufficienza ovarica precoce',
      'Menopausa chirurgica',
      'Malattia cardiovascolare',
      'Controindicazioni',
      'Fallimento della terapia ormonale',
      'Alternative non ormonali',
      'Casi clinici complessi',
    ],
  },
  {
    number: 'Volume 6',
    title: 'Il Kit di Strumenti per il Medico',
    lead: 'Tutto ciò di cui hai bisogno per gestire una pratica clinica dedicata alla menopausa in modo più organizzato e professionale.',
    body: 'Include risorse cliniche pronte all’uso.',
    listTitle: 'All’interno:',
    items: [
      'Modelli per le consultazioni',
      'Checklist cliniche',
      'Modelli di note SOAP',
      'Moduli per il follow-up',
      'Risorse educative per le pazienti',
      'Documenti per il consenso informato',
      'Script di comunicazione',
      'Strumenti per la documentazione',
    ],
  },
]

export const bonuses = [
  {
    tag: 'Bonus n. 1',
    title: 'Guida Rapida alla Terapia Ormonale™',
    image:
      'https://cdn.magicpatterns.com/uploads/9oRASGQ4xs4RRaoNKQkZTN/BONUS_1_MENOPAUSIA-IT.png',
    lead: 'Non perdere più tempo a cercare equivalenze di dosaggio.',
    body: 'Tabelle di consultazione rapida per farmaci, conversioni di dosaggio, modalità di somministrazione e raccomandazioni prescrittive.',
    items: [],
    value: '47 €',
  },
  {
    tag: 'Bonus n. 2',
    image:
      'https://cdn.magicpatterns.com/uploads/bFF1RDQCJZHpARfVc6icMu/BONUS_2_MENOPAUSIA-IT.png',
    title: 'Guida all’Interpretazione degli Esami di Laboratorio™',
    lead: 'Interpreta con sicurezza gli esami di laboratorio correlati alla menopausa in pochi minuti.',
    body: 'Include indicazioni pratiche per:',
    items: [
      'FSH',
      'Estradiolo',
      'LH',
      'Testosterone',
      'SHBG',
      'Profilo lipidico',
      'Salute ossea',
      'Vitamina D',
      'Algoritmi decisionali clinici',
    ],
    value: '47 €',
  },
  {
    tag: 'Bonus n. 3',
    image:
      'https://cdn.magicpatterns.com/uploads/5B1j3dsrWPQoNVVoJtV8XV/BONUS_3_MENOPAUSIA-IT.png',
    title: 'Script per Conversazioni Difficili con le Pazienti™',
    lead: 'Scopri esattamente cosa dire quando le pazienti pongono domande difficili sulla terapia ormonale.',
    body: 'Include framework di comunicazione pronti all’uso per discutere di:',
    items: [
      'Tumore al seno',
      'Coaguli di sangue',
      'Rischio cardiovascolare',
      'Aumento di peso',
      'Sicurezza degli ormoni',
      'Conversazioni su rischi e benefici',
    ],
    value: '67 €',
  },
  {
    tag: 'Bonus n. 4',
    image:
      'https://cdn.magicpatterns.com/uploads/odEyxF6XBUGr6yjbXHrKUT/BONUS_4_MENOPAUSIA-IT.png',
    title: 'Manuale per la Gestione delle Complicazioni™',
    lead: 'Algoritmi basati sulle evidenze per gestire sanguinamento, effetti collaterali, scarso controllo dei sintomi e fallimenti terapeutici.',
    body: 'Saprai esattamente cosa fare quando la terapia non procede come previsto.',
    items: [],
    value: '67 €',
  },
  {
    tag: 'Bonus n. 5',
    image:
      'https://cdn.magicpatterns.com/uploads/6VitjSxq2AiXCYQEDs7LmG/BONUS_5_MENOPAUSIA-IT.png',
    title: 'Kit di Strumenti per la Documentazione Clinica™',
    lead: 'Modelli professionali progettati per farti risparmiare tempo e migliorare la qualità della documentazione.',
    body: 'Include:',
    items: [
      'Moduli clinici',
      'Note SOAP',
      'Modelli per il follow-up',
      'Piani terapeutici',
      'Valutazioni del rischio',
      'Moduli di consenso',
      'Checklist per la documentazione',
    ],
    value: '67 €',
  },
]

export const offerLines = [
  { label: 'Progetto Clinico della Menopausa™ — 6 Volumi', value: '297 €' },
  { label: 'Guida Rapida alla Terapia Ormonale™', value: '47 €' },
  { label: 'Guida all’Interpretazione degli Esami di Laboratorio™', value: '47 €' },
  { label: 'Script per Conversazioni Difficili con le Pazienti™', value: '67 €' },
  { label: 'Manuale per la Gestione delle Complicazioni™', value: '67 €' },
  { label: 'Kit di Strumenti per la Documentazione Clinica™', value: '67 €' },
]

export const testimonials = [
  {
    quote:
      'Ho smesso di passare continuamente da una linea guida all’altra. Finalmente tutto ciò di cui ho bisogno è organizzato in un unico sistema clinico pratico.',
    name: 'Dr.ssa Sarah M.',
    role: 'Ginecologa e Ostetrica • Texas, USA',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7807f37a-fac3-4d03-81ae-1db187bb47f7.jpg',
  },
  {
    quote:
      'I soli algoritmi prescrittivi valgono diverse volte il prezzo di acquisto. Li utilizzo praticamente ogni giorno.',
    name: 'Dr. Michael R.',
    role: 'Medico di Medicina di Famiglia • Ontario, Canada',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c72794c4-bc8b-4f88-a1df-4b9e330daa6d.jpg',
  },
  {
    quote:
      'Gli script di comunicazione hanno completamente cambiato il modo in cui parlo della terapia ormonale con le pazienti. Quelle conversazioni difficili ora sono molto più semplici.',
    name: 'Dr.ssa Emily T.',
    role: 'Medico specialista in Salute Femminile • Australia',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/11d7c70d-2802-49bb-8a5a-27d6c2fa4fcd.jpg',
  },
  {
    quote:
      'Mi aspettavo un altro PDF. Quello che ho ricevuto è stato invece un sistema decisionale clinico che continuerò a utilizzare nella mia pratica.',
    name: 'Dr. James L.',
    role: 'Medicina Interna • Regno Unito',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/af5c4f87-3b27-4e7b-8189-34f5cba0d7c6.jpg',
  },
]

export const faqs = [
  {
    q: 'È adatto anche ai medici che lavorano fuori dagli Stati Uniti?',
    a: 'Sì. Il contenuto si basa su linee guida cliniche riconosciute a livello internazionale e può essere applicato in qualsiasi contesto sanitario.',
  },
  {
    q: 'È un acquisto una tantum?',
    a: 'Sì. Paghi una sola volta e ricevi accesso digitale al materiale senza alcun abbonamento mensile.',
  },
  {
    q: 'Tutto il materiale è scaricabile?',
    a: 'Sì. Riceverai accesso digitale alle risorse incluse nel sistema.',
  },
  {
    q: 'Il contenuto viene aggiornato?',
    a: 'Il sistema è progettato per mantenere una struttura clinica basata sulle evidenze e sulle raccomandazioni aggiornate.',
  },
]

export const purchaseNotices = [
  { name: 'María González', place: 'Città del Messico, Messico' },
  { name: 'Lucía Fernández', place: 'Buenos Aires, Argentina' },
  { name: 'Carlos Ramírez', place: 'Bogotá, Colombia' },
  { name: 'Ana Martínez', place: 'Madrid, Spagna' },
  { name: 'Javier Torres', place: 'Lima, Perù' },
  { name: 'Valentina Rojas', place: 'Santiago, Cile' },
  { name: 'Miguel Herrera', place: 'Montevideo, Uruguay' },
  { name: 'Paola Castillo', place: 'Quito, Ecuador' },
  { name: 'Andrés Morales', place: 'San José, Costa Rica' },
  { name: 'Camila Vargas', place: 'Asunción, Paraguay' },
  { name: 'Ricardo Silva', place: 'Panama City, Panama' },
  { name: 'Isabel Navarro', place: 'Barcellona, Spagna' },
]
